import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BlackBaudTransactionInfo {
  startDate: string;
  endDate: string;
  batchStatus: string;
  rowsPerPage: number;
  page: number;
}

const initialState: BlackBaudTransactionInfo = {
  startDate: "",
  endDate: "",
  batchStatus: "All",
  rowsPerPage: 5,
  page: 0,
};

const createBlackBaudTransactionLogSlice = createSlice({
  name: "blackBaudTransactionLog",
  initialState,
  reducers: {
    setCreateBlackBaudTransactionLog: (
      state,
      action: PayloadAction<Partial<BlackBaudTransactionInfo>>
    ) => {
      return { ...state, ...action.payload };
    },
    removeBlackBaudTransactionLog: () => initialState,
  },
});

export const { setCreateBlackBaudTransactionLog, removeBlackBaudTransactionLog } =
  createBlackBaudTransactionLogSlice.actions;
export default createBlackBaudTransactionLogSlice.reducer;
